module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (12).cfb0a6e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (12).jpg
// module id = 334
// module chunks = 0